import { Button, Stack, TextField } from '@mui/material';
import axios from '../../util/Axios';

import { useState } from 'react';

export function EditClinicalComment({ neurologicalExamination, onCancel, testId, onSaved }) {
  const [clinicianComment, setClinicianComment] = useState(neurologicalExamination?.clinicianComment);

  const handleSave = () => {
    const neurogicalExaminationToSave = {
      ...neurologicalExamination,
      clinicianComment,
    };

    axios(`/strokeTests/${testId}/neurologicalExamination/v2`, {
      method: 'PUT',
      data: neurogicalExaminationToSave,
    }).then(() => onSaved(neurogicalExaminationToSave), onCancel);
  };

  return (
    <Stack spacing={1}>
      <TextField
        sx={{
          display: 'flex',
          width: '100%',
          margin: 'auto',
          textAlign: 'center',
        }}
        multiline
        rows={4}
        label="Clinical comment"
        value={clinicianComment}
        onChange={(event) => setClinicianComment(event.target.value)}
      />
      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          {' '}
          Save{' '}
        </Button>
      </Stack>
    </Stack>
  );
}
